import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModalComponent } from './common-modal.component';
import { ComponentHostDirectiveModule } from 'src/app/directives/component-host/component-host.directive.module';

@NgModule({
  declarations: [
    CommonModalComponent
  ],
  entryComponents: [
    CommonModalComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ComponentHostDirectiveModule
  ],
  exports: [
    CommonModalComponent
  ]
})
export class CommonModalModule { }
